import React from 'react';
import styles from './index.module.scss';

const SportsBook = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='25' height='26.579' viewBox='0 0 25 26.579'>
            <g transform='translate(-2186.792 -223.25)'>
                <path
                    d='M2209.817,235.25h-5.13v.939a1.3,1.3,0,0,1-1.3,1.3H2195.2a1.3,1.3,0,0,1-1.3-1.3v-.939h-5.131a1.975,1.975,0,0,0-1.975,1.975v21.05a1.975,1.975,0,0,0,1.975,1.975h21.05a1.975,1.975,0,0,0,1.975-1.975v-21.05A1.975,1.975,0,0,0,2209.817,235.25Z'
                    transform='translate(0 -10.421)'
                    className={styles.light}
                />
                <rect
                    width='9.474'
                    height='3.158'
                    rx='1'
                    transform='translate(2194.555 223.25)'
                    className={styles.light}
                />
                <g transform='translate(2190.213 229.729)'>
                    <rect width='18.158' height='1.779' rx='0.889' className={styles.dark} />
                    <rect
                        width='14.073'
                        height='1.232'
                        rx='0.616'
                        transform='translate(4.039 5.755)'
                        className={styles.dark}
                    />
                    <path
                        d='M2213.573,292A1.507,1.507,0,1,0,2215,293.5,1.468,1.468,0,0,0,2213.573,292Zm.885,1.009-.94,1.39-.726-.49a.212.212,0,0,1-.059-.284.189.189,0,0,1,.269-.062l.414.28.725-1.073a.189.189,0,0,1,.271-.048A.213.213,0,0,1,2214.458,293.008Z'
                        transform='translate(-2212.1 -287.133)'
                        className={styles.dark}
                    />
                    <rect
                        width='14.073'
                        height='1.232'
                        rx='0.616'
                        transform='translate(4.039 10.229)'
                        className={styles.dark}
                    />
                    <path
                        d='M2213.573,332A1.507,1.507,0,1,0,2215,333.5,1.468,1.468,0,0,0,2213.573,332Zm.885,1.009-.94,1.39-.726-.49a.212.212,0,0,1-.059-.284.189.189,0,0,1,.269-.062l.414.28.725-1.073a.189.189,0,0,1,.271-.048A.213.213,0,0,1,2214.458,333.008Z'
                        transform='translate(-2212.1 -322.66)'
                        className={styles.dark}
                    />
                    <rect
                        width='14.073'
                        height='1.232'
                        rx='0.616'
                        transform='translate(4.039 14.702)'
                        className={styles.dark}
                    />
                    <path
                        d='M2213.573,372A1.507,1.507,0,1,0,2215,373.5,1.468,1.468,0,0,0,2213.573,372Zm.885,1.009-.94,1.39-.726-.49a.212.212,0,0,1-.059-.284.189.189,0,0,1,.269-.062l.414.28.725-1.073a.189.189,0,0,1,.271-.048A.213.213,0,0,1,2214.458,373.008Z'
                        transform='translate(-2212.1 -358.186)'
                        className={styles.dark}
                    />
                </g>
            </g>
        </svg>
    );
};

export default SportsBook;
